module.exports = "<p>\n  store-results works!\n</p>\n"